<ion-content>
  <div class="d-flex align-items-center justify-content-center w-100 h-100 p-4 flex-column">
    @if (!showSuccess) {
      <form #form=ngForm (ngSubmit)="submit()" [formGroup]="resetForm" class="w-100 auth-form" novalidate>
        <ion-text>
          <h4 class="mt-0 mb-0">Reset Password</h4>
          <p>Enter your email address below and we'll send you a link to reset your password.</p>
        </ion-text>
        <div class="mb-3">
          <ion-item class="no-inner-padding custom-input--login">
            <ion-label class="mt-0 label-form" position="stacked">Email Address</ion-label>
            <ion-input class="input-field" formControlName="emailAddress" type="email"></ion-input>
          </ion-item>
          <sm-validation [formGroup]="resetForm" [form]="form" controlName="emailAddress"></sm-validation>
        </div>
        <ion-button [disabled]="isSubmitting" expand="full" type="submit">Send Reset Link</ion-button>
      </form>
    }
    @if (showSuccess) {
      <ion-text class="auth-form">
        <h4 class="mt-0 mb-0">Request Sent</h4>
        <p>If the address you specified has a valid account, then an email containing password reset instructions has been sent.</p>
      </ion-text>
    }
    <ion-button color="light" expand="full" routerLink="/login"> Back to login</ion-button>
  </div>
</ion-content>
